// GenericModal.jsx
import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui";

const GenericModal = ({
  show,
  onHide,
  title,
  children,
  onConfirm,
  confirmText,
  cancelText,
  size,
}) => {
  const { t } = useTranslation("layout");
  return (
    <Modal show={show} onHide={onHide} size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} variant="secondary">
          {cancelText ?? t("genericModal.cancel")}
        </Button>
        <Button onClick={onConfirm} variant="primary">
          {confirmText ?? t("genericModal.confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenericModal;
